import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=8ee7476a&scoped=true"
import script from "./SearchResults.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResults.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=8ee7476a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee7476a",
  null
  
)

export default component.exports